"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

import { isPublicBookingRoute } from "@calcom/web/lib/metaTracking/Runtime";

import { googleAnalytics } from "./client";

export default function GoogleTrackingRuntime() {
  const pathname = usePathname();
  const lastPathname = useRef<string | null>(null);
  const enabled = isPublicBookingRoute(pathname) && googleAnalytics.isConfigured();
  const tagId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID || process.env.NEXT_PUBLIC_GOOGLE_ADS_ID;

  useEffect(() => {
    if (!enabled) {
      lastPathname.current = null;
      return;
    }
    googleAnalytics.init();
    if (lastPathname.current !== pathname) {
      lastPathname.current = pathname;
      googleAnalytics.pageView(pathname ?? "");
    }
  }, [enabled, pathname]);

  if (!enabled || !tagId) return null;
  return (
    <Script
      id="selfieroom-google-tag"
      src={`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(tagId)}`}
      strategy="afterInteractive"
    />
  );
}
